import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteError } from 'react-router-dom';

import { LogsEnums, LogsQuery } from 'dashboard-services/api/logs';
import Query from 'dashboard-services/api/Query';
import { ErrorBoundary } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';
import { sendEvent } from 'services/GAService';

import { useMutation } from '@tanstack/react-query';

const useSendLog = ({ getQueryBuilder }) =>
  useMutation({
    ...LogsQuery.QUERIES.send(
      getQueryBuilder,
      {
        logger: LogsEnums.LOGGER.DASHBOARD,
        level: LogsEnums.LOG_LEVEL.ERROR,
      }
    )
  })

const ErrorBoundaryLocal = ({ ...props }) => {
  const dispatch = useDispatch(),
        routeError = useRouteError(),
        userName = useSelector(state => state.myAccountState.settingsState.userName),
        version = properties.version,
        getQueryBuilder = useCallback(() => 
          new Query.Builder(dispatch(getApiConfig()))
            .withFetching(false)
            .withShouldDisplayError(false)
        , [dispatch]),
        { mutateAsync: sendErrorLogCall } = useSendLog({ getQueryBuilder }),
        sendErrorLog = useCallback(({ message, userName }) => {
          dispatch(sendEvent({ category: "exception", "description": message, fatal: true, action: "exception" }))
          return sendErrorLogCall({ message, userName })
        }, [dispatch, sendErrorLogCall]),
        accessGetApiConfig = useCallback(() => dispatch(getApiConfig()), [dispatch])

  return (
    <ErrorBoundary
        {...props}
        accessGetApiConfig={accessGetApiConfig}
        sendErrorLog={sendErrorLog}
        shouldDisplayError={props.shouldDisplayError ?? (routeError !== undefined && routeError !== null)}
        userName={userName}
        version={version}
    />
  )
}

export default ErrorBoundaryLocal;
